(function ($, Drupal, once) {
  Drupal.behaviors.siteNavigation = {
    attach: function (context, settings) {
      $(once('siteNavigation', '.menu--main .menu-item--expanded', context)).each(function () {
        $(this).mouseover(function () {
          $(this).siblings('.dropdown-menu.sub-menu').addClass('show');
        }).mouseout(function () {
          $(this).siblings('.dropdown-menu.sub-menu').removeClass('show');
        });
      });

      $(once('siteNavigation', '.dropdown-menu.sub-menu', context)).each(function () {
        $(this).mouseover(function () {
          $(this).addClass('show');
        }).mouseout(function () {
          $(this).removeClass('show');
        });
      });
    }
  };
})(jQuery, Drupal, once);
